export default __webpack_public_path__ + "static/media/a1-3-4.79808726.jpg";